import { styled } from '../../stitches.config';

export const DeprecatedSidebarGroup = styled('div', {
  vStack: '$4',
  alignItems: 'stretch',
  padding: '10px $12',
});
